import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import {
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Grid,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import impactImg1 from "../Images/c1.png";
import impactImg2 from "../Images/c2.png";
import impactImg3 from "../Images/c3.png";
import impactImg4 from "../Images/c4.png";

const impactImages = [impactImg1, impactImg2, impactImg3, impactImg4];

const OurImpactCarousel = () => {
  const [index, setIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % impactImages.length);
  };

  const handleBack = () => {
    setIndex((prev) => (prev - 1 + impactImages.length) % impactImages.length);
  };

  return (
    <Box
      sx={{
        width: "100%",
        margin: "auto",
        px: isMobile ? 2 : 4,
        py: 4,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
        mt: 6,
      }}
    >
      {/* Heading and navigation */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 4,
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
          variant={isMobile ? "h5" : "h4"}
          fontWeight="bold"
          sx={{ textAlign: isMobile ? "center" : "left" }}
        >
          Our Impact
        </Typography>

        <Box display="flex" gap={2}>
          <IconButton
            onClick={handleBack}
            sx={{
              backgroundColor: "#54b06f",
              color: "#fff",
              "&:hover": { backgroundColor: "#42965c" },
              borderRadius: "50%",
              width: 48,
              height: 48,
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            sx={{
              backgroundColor: "#54b06f",
              color: "#fff",
              "&:hover": { backgroundColor: "#42965c" },
              borderRadius: "50%",
              width: 48,
              height: 48,
            }}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      </Box>

      {/* Carousel */}
      <SwipeableViews index={index} onChangeIndex={setIndex} enableMouseEvents>
        {impactImages.map((img, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: isMobile ? 1 : 2,
            }}
          >
            <Box
              component="img"
              src={img}
              alt={`Impact graph ${i + 1}`}
              sx={{
                borderRadius: "12px",
                maxHeight: isMobile ? 250 : 400,
                width: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        ))}
      </SwipeableViews>
    </Box>
  );
};

export default OurImpactCarousel;
